import { useState } from "react";
import axios from "axios";
import { CleanupSuppressedEmails, CleanupSuppressions } from "../apiconstants/constants";
import ConsultantLayout from "../commonlayouts/consultantlayout";
 
const Cleanup = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");
 const token = localStorage.getItem("jwtToken");

 const handleCleanup = async () => {
  try {
    setLoading(true);
    setResult("");
 
    const response = await axios.get(CleanupSuppressedEmails.APIURL,
      { headers: { Authorization: `Bearer ${token}` } }

    );
 
    const message = response?.data?.sendGrid?.message;
 
    if (message === "SendGrid suppressions cleanup complete") {
      setResult(response.data); // store full response
    } else {
      setResult({ message: message || "Cleanup completed with messages" });
    }
 
  } catch (error) {
    console.error(error);
    setResult({ message: "Error while processing cleanup." });
  } finally {
    setLoading(false);
  }
};
 
 
  return (
    <ConsultantLayout>
      <div style={{ height: 500 }}>
        <h2 className="p-3" style={{ color: "#00a7ac" }}>Mails Clean Up</h2>
        <hr />
 
        <div className="d-flex justify-content-center mt-3">
          <button
            className="btn btn-primary"
            onClick={handleCleanup}
            disabled={loading}
            style={{ padding: "10px", cursor: "pointer" }}
          >
            {loading ? "Processing..." : "Start Cleanup Emails"}
          </button>
        </div>
 
   <div>{result && result.deletedCounts && (
 <div className="mt-4" style={{ textAlign: "left", marginLeft: "40px" }}>
    <p>Bench Candidates Profile: <strong>{result.deletedCounts.fromBenchCandidateProfile}</strong></p>
 
    <p>Candidate Outreach: <strong>{result.deletedCounts.fromCandidateOutreach}</strong></p>
 
    <p>Candidate Submissions: <strong>{result.deletedCounts.fromCandidateSubmissions}</strong></p>
 
    <p>Leads: <strong>{result.deletedCounts.fromLeads}</strong></p>
 
    <p>Candidate Schedule: <strong>{result.deletedCounts.fromCandIntSchDet}</strong></p>
 
    <p>Staffing Contacts: <strong>{result.deletedCounts.fromHotList}</strong></p>
 
    <p>Hotlist Outreach: <strong>{result.deletedCounts.fromHotlistOutreach}</strong></p>
 
    <p className="mt-3 text-success fw-bold">
      SendGrid Status: {result.sendGrid?.message=='SendGrid suppressions cleanup complete' ? "Cleanup Successfull" : "Error while Processing"}
    </p>
  </div>
)}
 
      </div></div>
    </ConsultantLayout>
  );
};
 
export default Cleanup;
 
 